// Utilitário para testar notificações diretamente
export const testNotification = async () => {
  // Verificar se notificações são suportadas
  if (!('Notification' in window)) {
    alert('❌ Este navegador não suporta notificações!');
    return false;
  }

  // Verificar permissão atual
  let permission = Notification.permission;
  console.log('Permissão atual:', permission);

  // Se não tiver permissão, solicitar
  if (permission === 'default') {
    permission = await Notification.requestPermission();
    console.log('Nova permissão:', permission);
  }

  if (permission !== 'granted') {
    alert(`❌ Permissão negada! Status: ${permission}\n\nVá em:\n1. Cadeado na barra de endereços → Notificações → Permitir\n2. Ou: chrome://settings/content/notifications`);
    return false;
  }

  // Testar notificação simples
  try {
    const notification = new Notification('🔔 Teste de Notificação', {
      body: 'Se você vê isso, as notificações funcionam!',
      icon: '/android-chrome-192x192.png',
      badge: '/favicon-32x32.png',
      tag: 'test-notification',
      requireInteraction: false,
      silent: false
    });

    console.log('✅ Notificação criada:', notification);
    
    notification.onclick = () => {
      console.log('Notificação clicada!');
      window.focus();
      notification.close();
    };

    notification.onshow = () => {
      console.log('✅ Notificação EXIBIDA na tela!');
    };

    notification.onerror = (error) => {
      console.error('❌ Erro ao exibir notificação:', error);
    };

    notification.onclose = () => {
      console.log('Notificação fechada');
    };

    // Fechar após 5 segundos
    setTimeout(() => {
      notification.close();
    }, 5000);

    return true;
  } catch (error) {
    console.error('❌ Erro ao criar notificação:', error);
    alert('❌ Erro ao criar notificação: ' + error.message);
    return false;
  }
};

// Testar via service worker
export const testServiceWorkerNotification = async () => {
  if (!('serviceWorker' in navigator)) {
    alert('❌ Service Worker não suportado!');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    console.log('Service Worker pronto:', registration);

    const result = await registration.showNotification('🔔 Teste via Service Worker', {
      body: 'Se você vê isso, o service worker pode mostrar notificações!',
      icon: '/android-chrome-192x192.png',
      badge: '/favicon-32x32.png',
      tag: 'test-sw-notification',
      requireInteraction: false,
      silent: false,
      vibrate: [200, 100, 200]
    });

    console.log('✅ Notificação via SW criada:', result);
    return true;
  } catch (error) {
    console.error('❌ Erro ao criar notificação via SW:', error);
    alert('❌ Erro: ' + error.message);
    return false;
  }
};

